import { createConfirmation } from 'react-confirm'
import ModalBody from "./ModalBody";

const modal = createConfirmation(ModalBody);

export default function (opts = {}) {
  if (!opts.pageTitle || !opts.pageUrl) {
    throw new Error('pageTitle and pageUrl are not defined.');
  }
  
  return modal(opts);
}



// WEBPACK FOOTER //
// ./src/template/Modals/ShareOnSocialMedia/index.js